import { AggregationOperation, ConsumptionPreferenceRequest, ConsumptionPreferenceState, InventoryMonitoringPortalViewType, PaginationType, SelectComponent } from "../../../interfaces/consumptionPreferenceInterfaces";
import { DateRange } from "../../../interfaces/unifiedInventoryMovementInterfaces";
import { DEFAULT_PREFERENCES_UAT } from "../../../pages/UnifiedMovementSystem/ConsumptionPreference_UAT/components/CPLTableView/components/ConsumptionCPLDashboardPreferences";
import { HISTORICAL_QTY_CONSUMPTION_DEFAULT_PREFERENCES } from "../../../pages/UnifiedMovementSystem/ConsumptionPreference_UAT/components/CPLTrendView/components/DetailedAnalysis/HistoricalQtyConsumptionPreferences";
import { getDefaultMonths, getLastMonthOption } from "../../../pages/UnifiedMovementSystem/ConsumptionPreference_UAT/utils/ConsumptionCPLUtil";
import { ConsumptionPreferenceActions } from "../actions/consumptionPreferenceActions";
import { UPDATE_ALL_TABLE_DATA, UPDATE_CURRENT_TAM, UPDATE_DATE_EDITS_MODAL, UPDATE_DROPDOWN_LOADING, UPDATE_GSM_NAME, UPDATE_GSM_OPTIONS, UPDATE_PREFERENCE_DASHBOARD_TABLE_DATA, UPDATE_PREFERENCES, 
    UPDATE_SELECTED_END_DATE, UPDATE_SELECTED_SFG_ID, UPDATE_SELECTED_START_DATE, UPDATE_SFG_DATA_IN_PROGRESS, UPDATE_SFG_ID_LIST, UPDATE_SFG_DROPDOWN_VALUES, UPDATE_START_TIME_VALUE, UPDATE_SUPER_SET_ID, UPDATE_TAM_END_DATE, 
    UPDATE_TAM_START_DATE, UPDATE_UPDATED_END_DATE, UPDATE_UPDATED_START_DATE, UPDATE_SFG_DROPDOWN_LIST, UPDATE_UAT_PREFERENCES, UPDATE_SFG_ID_NAME_MAPPING, UPDATE_HISTORICAL_QTY_CONSUMPTION_TABLE_DATA, UPDATE_HISTORICAL_QTY_CONSUMPTION_SEARCH_REQUEST, 
    UPDATE_TRENDS_VIEW_DATE_RANGE, UPDATE_TRENDS_VIEW_SEARCH_REQUEST, UPDATE_SELECTED_LOGICAL_GROUP, UPDATE_LOGICAL_GROUP_DROPDOWN_VALUES, UPDATE_LOGICAL_GROUP_LIST, UPDATE_SELECTED_IPN, UPDATE_IPN_DROPDOWN_VALUES, UPDATE_SELECTED_MONTH, 
    UPDATE_HISTORICAL_QTY_CONSUMPTION_PREFERENCES, UPDATE_COMPUTED_MONTHS_OPTIONS} from "../types/consumptionPreferenceTypes";

const searchRequest: ConsumptionPreferenceRequest = {
    searchCriteria: {},
    viewType: InventoryMonitoringPortalViewType.AGGREGATED_CONSUMPTION_DATA,
    aggregationCriteriaList: [
        {
            name: "SUPERSET_NAME",
            typeCriteria: {
                type: {
                    operation: AggregationOperation.TERMS
                },
                field: "SUPERSET_NAME"
            },
            aggregationCriteriaList: [
                {
                    name: "LOGICAL_GROUP",
                    typeCriteria: {
                        type: {
                            operation: AggregationOperation.TERMS
                        },
                        field: "LOGICAL_GROUP"
                    },
                    aggregationCriteriaList: [
                        {
                            name: "IPN",
                            typeCriteria: {
                                type: {
                                    operation: AggregationOperation.TERMS
                                },
                                field: "IPN"
                            },
                            aggregationCriteriaList: [
                                {
                                    name: "SUPPLIER",
                                    typeCriteria: {
                                        type: {
                                            operation: AggregationOperation.TERMS
                                        },
                                        field: "SUPPLIER"
                                    },
                                    aggregationCriteriaList: [
                                        {
                                            name: "ACTUAL_TAM",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "ACTUAL_TAM"
                                            }
                                        },
                                        {
                                            name: "DEVIATION_PERCENTAGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "DEVIATION_PERCENTAGE"
                                            }
                                        },
                                        {
                                            name: "DEVIATION_REASON",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.TERMS
                                                },
                                                field: "DEVIATION_REASON"
                                            }
                                        },
                                        {
                                            name: "CURRENT_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "CURRENT_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "CONSUMED_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "CONSUMED_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "ALLOCATED_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "ALLOCATED_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "RESERVED_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "RESERVED_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "RECEIVED_AGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "RECEIVED_AGE"
                                            }
                                        },
                                        {
                                            name: "INVENTORY_OWNERSHIP_AGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "INVENTORY_OWNERSHIP_AGE"
                                            }
                                        },
                                        {
                                            name: "RESERVATION_AGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "RESERVATION_AGE"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    paginationType: PaginationType.OFFSET_BASED,
}

const historicalQtyConsumptionSearchRequest: ConsumptionPreferenceRequest = {
    searchCriteria: {},
    viewType: InventoryMonitoringPortalViewType.HISTORICAL_QUANTITY_CONSUMPTION_DATA,
    aggregationCriteriaList: [
        {
            name: "SUPERSET_NAME.KEYWORD",
            typeCriteria: {
                type: {
                    operation: AggregationOperation.TERMS
                },
                field: "SUPERSET_NAME.KEYWORD"
            },
            aggregationCriteriaList: [
                {
                    name: "LOGICAL_GROUP",
                    typeCriteria: {
                        type: {
                            operation: AggregationOperation.TERMS
                        },
                        field: "LOGICAL_GROUP"
                    },
                    aggregationCriteriaList: [
                        {
                            name: "IPN",
                            typeCriteria: {
                                type: {
                                    operation: AggregationOperation.TERMS
                                },
                                field: "IPN"
                            },
                            aggregationCriteriaList: [
                                {
                                    name: "SUPPLIER",
                                    typeCriteria: {
                                        type: {
                                            operation: AggregationOperation.TERMS
                                        },
                                        field: "SUPPLIER"
                                    },
                                    aggregationCriteriaList: [
                                        {
                                            name: "BURN_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "BURN_QUANTITY"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    paginationType: PaginationType.OFFSET_BASED,
}

const trendsViewSearchRequest: ConsumptionPreferenceRequest = {
    searchCriteria: {},
    aggregationCriteriaList: [
        {
            name: "SUPERSET_NAME",
            typeCriteria: {
                type: {
                    operation: AggregationOperation.TERMS
                },
                field: "SUPERSET_NAME"
            },
            aggregationCriteriaList: [
                {
                    name: "LOGICAL_GROUP",
                    typeCriteria: {
                        type: {
                            operation: AggregationOperation.TERMS
                        },
                        field: "LOGICAL_GROUP"
                    },
                    aggregationCriteriaList: [
                        {
                            name: "IPN",
                            typeCriteria: {
                                type: {
                                    operation: AggregationOperation.TERMS
                                },
                                field: "IPN"
                            },
                            aggregationCriteriaList: [
                                {
                                    name: "SUPPLIER",
                                    typeCriteria: {
                                        type: {
                                            operation: AggregationOperation.TERMS
                                        },
                                        field: "SUPPLIER"
                                    },
                                    aggregationCriteriaList: [
                                        {
                                            name: "ACTUAL_TAM",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "ACTUAL_TAM"
                                            }
                                        },
                                        {
                                            name: "DEVIATION_PERCENTAGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "DEVIATION_PERCENTAGE"
                                            }
                                        },
                                        {
                                            name: "DEVIATION_REASON",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.TERMS
                                                },
                                                field: "DEVIATION_REASON"
                                            }
                                        },
                                        {
                                            name: "CURRENT_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "CURRENT_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "CONSUMED_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "CONSUMED_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "ALLOCATED_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "ALLOCATED_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "RESERVED_QUANTITY",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.SUM
                                                },
                                                field: "RESERVED_QUANTITY"
                                            }
                                        },
                                        {
                                            name: "RECEIVED_AGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "RECEIVED_AGE"
                                            }
                                        },
                                        {
                                            name: "INVENTORY_OWNERSHIP_AGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "INVENTORY_OWNERSHIP_AGE"
                                            }
                                        },
                                        {
                                            name: "RESERVATION_AGE",
                                            typeCriteria: {
                                                type: {
                                                    operation: AggregationOperation.AVERAGE
                                                },
                                                field: "RESERVATION_AGE"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    paginationType: PaginationType.OFFSET_BASED,
    rangeCriteria: {
      from: 0,
      to: 0
    }
}

const initialState: ConsumptionPreferenceState = {
    selectedGSM: "",
    currentTAM: "",
    gsmOptions: [],
    isDropDownLoading: true,
    uatPreferences: DEFAULT_PREFERENCES_UAT,
    sfgIdDropdownValues: [],
    preferenceDashboardTableData: [],
    allTableData: [],
    startTimeValue: (new Date().valueOf()),
    selectedSfgId: {label: "All", value: "All"},
    showDateEditsModal: false,
    superSetId: "",
    selectedStartDate: "",
    selectedEndDate: "",
    isSfgDataUpdateInProgress: null,
    updatedStartDate: "",
    updatedEndDate: "",
    tamStartDate: "",
    tamEndDate: "",
    searchRequest: searchRequest,
    sfgIdList: [],
    sfgDropdownList: [],
    sfgIdNameMapping: [],
    trendsViewSearchRequest: trendsViewSearchRequest,
    trendsViewDateRange: {},
    logicalGroupList: [],
    selectedLogicalGroup: {label: "", value: ""},
    logicalGroupDropdownValues: [],
    selectedIPN: {label: "All", value: "All"},
    IPNDropdownValues: [],
    selectedMonth: getLastMonthOption(),
    historicalQtyConsumptionTableData: [],
    historicalQtyConsumptionSearchRequest: historicalQtyConsumptionSearchRequest,
    historicalQtyConsumptionPreference: HISTORICAL_QTY_CONSUMPTION_DEFAULT_PREFERENCES,
    updateComputedMonthsOptions: getDefaultMonths(),
}
export const consumptionPreferenceReducer = (state = initialState, action: ConsumptionPreferenceActions) : ConsumptionPreferenceState =>{
    switch(action.type){
        case UPDATE_GSM_NAME:
            return {
                ...state,
                selectedGSM: action.payload
            }
        case UPDATE_CURRENT_TAM:
            return {
                ...state,
                currentTAM: action.payload as string
            }
        case UPDATE_GSM_OPTIONS:
            return {
                ...state,
                gsmOptions: action.payload as SelectComponent[]
            }
        case UPDATE_DROPDOWN_LOADING:
            return {
                ...state,
                isDropDownLoading: action.payload as boolean
            }
        case UPDATE_UAT_PREFERENCES:
            return {
                ...state,
                uatPreferences: action.payload as any
            }
        case UPDATE_SFG_DROPDOWN_VALUES:
            return {
                ...state,
                sfgIdDropdownValues: action.payload as any
            }
        case UPDATE_PREFERENCE_DASHBOARD_TABLE_DATA:
            return {
                ...state,
                preferenceDashboardTableData: action.payload as any
            }
        case UPDATE_ALL_TABLE_DATA:
            return {
                ...state,
                allTableData: action.payload as any
            }
        case UPDATE_START_TIME_VALUE:
            return {
                ...state,
                startTimeValue: action.payload as any
            }
        case UPDATE_SELECTED_SFG_ID:
            return {
                ...state,
                selectedSfgId: action.payload as any
            }
        case UPDATE_DATE_EDITS_MODAL:
            return {
                ...state,
                showDateEditsModal: action.payload as boolean
            }
        case UPDATE_SUPER_SET_ID:
            return {
                ...state,
                superSetId: action.payload as string
            }
        case UPDATE_SELECTED_START_DATE:
            return {
                ...state,
                selectedStartDate: action.payload as any
            }
        case UPDATE_SELECTED_END_DATE:
            return {
                ...state,
                selectedEndDate: action.payload as any
            }
        case UPDATE_SFG_DATA_IN_PROGRESS:
            return {
                ...state,
                isSfgDataUpdateInProgress: action.payload as any
            }
        case UPDATE_UPDATED_START_DATE:
            return {
                ...state,
                updatedStartDate: action.payload as any
            }
        case UPDATE_UPDATED_END_DATE:
            return {
                ...state,
                updatedEndDate: action.payload as any
            }
        case UPDATE_TAM_START_DATE:
            return {
                ...state,
                tamStartDate: action.payload as any
            }
        case UPDATE_TAM_END_DATE:
            return {
                ...state,
                tamEndDate: action.payload as any
            }
        case UPDATE_SFG_ID_LIST:
            return {
                ...state,
                sfgIdList: action.payload as SelectComponent[]
            }
        case UPDATE_SFG_DROPDOWN_LIST:
            return {
                ...state,
                sfgDropdownList: action.payload as SelectComponent[]
            }
        case UPDATE_SFG_ID_NAME_MAPPING:
            return {
                ...state,
                sfgIdNameMapping: action.payload as SelectComponent[]
            }
        case UPDATE_TRENDS_VIEW_SEARCH_REQUEST: 
            return {
                ...state,
                trendsViewSearchRequest: action.payload as ConsumptionPreferenceRequest
            }
        case UPDATE_TRENDS_VIEW_DATE_RANGE:
            return {
                ...state,
                trendsViewDateRange: action.payload as DateRange
            }
        case UPDATE_LOGICAL_GROUP_LIST:
            return {
                ...state,
                logicalGroupList: action.payload as SelectComponent[]
            }
        case UPDATE_SELECTED_LOGICAL_GROUP:
            return {
                ...state,
                selectedLogicalGroup: action.payload as any
            }
        case UPDATE_LOGICAL_GROUP_DROPDOWN_VALUES:
            return {
                ...state,
                logicalGroupDropdownValues: action.payload as any
            }
        case UPDATE_SELECTED_IPN:
            return {
                ...state,
                selectedIPN: action.payload as any
            }
        case UPDATE_IPN_DROPDOWN_VALUES:
            return {
                ...state,
                IPNDropdownValues: action.payload as any
            }
        case UPDATE_SELECTED_MONTH:
            return {
                ...state,
                selectedMonth: action.payload as any
            }
        case UPDATE_HISTORICAL_QTY_CONSUMPTION_TABLE_DATA:
            return {
                ...state,
                historicalQtyConsumptionTableData: action.payload as any
            }
        case UPDATE_HISTORICAL_QTY_CONSUMPTION_SEARCH_REQUEST:
            return {
                ...state,
                historicalQtyConsumptionSearchRequest: action.payload as ConsumptionPreferenceRequest
            }
        case UPDATE_HISTORICAL_QTY_CONSUMPTION_PREFERENCES:
            return {
                ...state,
                historicalQtyConsumptionPreference: action.payload as any
            }
        case UPDATE_COMPUTED_MONTHS_OPTIONS:
            return {
                ...state,
                updateComputedMonthsOptions: action.payload as any
            };
        default:
            return state;
    }
}